/**
 * Canonical React path map for financial/operational reports (sidebar, deep links, redirects).
 * LEGACY_REPORT_SLUG_TO_REACT mirrors backend config/report_routes.php for Blade → SPA migration.
 * Prefer these constants over hard-coded paths; legacy portal via legacyReportsPortal + openLegacyReportsPortal().
 */
export const REPORT_ROUTES = {
  accountStatement: '/statement-of-account',
  accountStatementWithHead: (headId) => `/statement-of-account/${headId}`,
  dailyTransaction: '/daily-transaction-sheet',
  dailyTransactionSummary: '/daily-transaction-summary',
  tradeProfitLoss: '/trade-profit-loss',
  shortExcess: '/short-excess-report',
  otherIncome: '/other-income-report',
  customerStatement: '/customer-statement',
  bankStatement: '/bank-statement',
  otherReports: (slug) => `/other-reports/${slug}`,
  /** Opens Laravel Blade portal on backend host — use openLegacyReportsPortal() from utils/legacyReports.js */
  legacyReportsPortal: '/legacy-reports',
  dealerStatement: '/dealer-statement',
  fleetCardStatement: '/fleetcard-statement',
  mlaCouponStatement: '/mla-coupon-statement',
  nonFuelPurchase: '/nonfuel-purchase-report',
  nonFuelSales: '/nonfuel-sales-report',
  nonFuelStock: '/nonfuel-stock-statement',
  recoupStatement: '/recoup-statement',
  nozzleReport: '/nozzle-report',
  stockGainLoss: '/stock-gain-loss',
};

/** Legacy other-report slug → React path (mirrors backend config/report_routes.php). */
export const LEGACY_REPORT_SLUG_TO_REACT = {
  account_statements: REPORT_ROUTES.accountStatement,
  'daily-transaction-sheet': REPORT_ROUTES.dailyTransaction,
  trade_loss_gain: REPORT_ROUTES.tradeProfitLoss,
  short_excess_statement: REPORT_ROUTES.shortExcess,
  other_income_statement: '/other-reports/other_income_statement',
  customer_statement: REPORT_ROUTES.customerStatement,
  bank_statement: '/other-reports/bank_statement',
  dealer_statement: REPORT_ROUTES.dealerStatement,
  fleetcard_statement: REPORT_ROUTES.fleetCardStatement,
  mla_coupon_statement: REPORT_ROUTES.mlaCouponStatement,
  product_purchase_statement: REPORT_ROUTES.nonFuelPurchase,
  product_sales_statement: REPORT_ROUTES.nonFuelSales,
  'stock-gain-loss': REPORT_ROUTES.stockGainLoss,
  ownerfunds_statement: '/other-reports/ownerfunds_statement',
  gst_setoff: '/other-reports/gst_setoff',
  nozzle_report: '/other-reports/nozzle_report',
  bag_statement: '/other-reports/bag_statement',
  closing_cash_statement: '/other-reports/closing_cash_statement',
  vehicle_statements: '/other-reports/vehicle_statements',
  fuel_ps: '/other-reports/fuel_ps',
  alltransactions: '/other-reports/alltransactions',
  stock_report: '/other-reports/stock_report',
  exp_statement: '/other-reports/exp_statement',
  fuel_purchase: '/other-reports/fuel_purchase',
  fuel_sales: '/other-reports/fuel_sales',
  gas_purchase: '/other-reports/gas_purchase',
  gas_sales: '/other-reports/gas_sales',
  gas_stock: '/other-reports/gas_stock',
};

export default REPORT_ROUTES;
